<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="primary--text mb-2 font-weight-bold">
          Filtrar
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseSelect
          placeholder="Tipos de Filtros"
          :items="listTypesFilter"
          v-model="quotationFilter.tipo"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-md-5 pr-0">
        <BaseFilter
          v-model="quotationFilter.valor"
          :textPlaceholder="'Informe'"
          hide-no-data
          item-text="nome"
          item-value="id"
          validate-on-blur
          :return-object="true"
          required
          :rules="[requiredInput]"
        />
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="6" md="2" class="pr-0 pb-5 pb-md-0 pr-sm-3">
        <BaseButton
          v-html="'PESQUISAR'"
          class="secondary white--text"
          width="100%"
          @click="searchByFilter"
        />
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pb-5 pb-md-0">
        <BaseButton
          v-html="'LIMPAR'"
          color="secondary"
          width="100%"
          outlined
          @click="resetFilter"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="header"
          :items="listApoliceAgro"
          no-data-text="Nenhuma Cotação foi encontrada"
          loading-text="Carregando Cotações..."
          :options.sync="options"
          :server-items-length="totalQuotation"
          class="policyTable base__datatable"
          @click:row="redirectToQuotation"
          :footer-props="{ 'items-per-page-options': [25, 50, 100, 250, 500] }"
        >
          <template v-slot:[`item.numero`]="{ item }">
            <div class="policyTable__padding">
              {{ item.numero }}
            </div>
          </template>
          <template v-slot:[`item.status.nome`]="{ item }">
            <div :class="borderColor(item.status)">
              <div class="policyTable__padding">
                {{ item.status.nome }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.inicio_vigencia`]="{ item }">
            {{ formatDates(item.inicio_vigencia, item.fim_vigencia) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "N° da Solicitação", value: "numero", sortable: false },
  { text: "Canal", value: "canal", sortable: false },
  { text: "Segurado", value: "segurado.nome", sortable: false },
  { text: "CPF/CNPJ", value: "segurado.numero_documento", sortable: false },
  { text: "Vigência", value: "inicio_vigencia", sortable: false },
  { text: "Produto", value: "produto", sortable: false },
  { text: "Cultura", value: "submodalidade.nome", sortable: false },
  { text: "Status", value: "status.nome", sortable: false }
];

const colorByStatus = [{ color: "light-blue", status: "apolice_emitida" }];

const DEFAULT_STATUS = { color: "light-blue" };

const MOCK_FILTER = {
  valor: null,
  tipo: {
    nome: null,
    id: null
  },
  filter: null,
  inicio: null,
  fim: null
};

const MOCK_TYPES_FILTER = [
  {
    nome: "Segurado",
    id: "segurado"
  },
  {
    nome: "CPF/CNPJ",
    id: "numero_documento"
  },
  {
    nome: "Número Solicitação",
    id: "numero"
  },
  {
    nome: "Status",
    id: "status"
  },
  {
    nome: "Canal",
    id: "grupo_economico"
  },
  {
    nome: "Produto",
    id: "modalidades"
  },
  {
    nome: "Cultura",
    id: "submodalidades"
  },
  {
    nome: "Seguradora",
    id: "seguradoras"
  },
  {
    nome: "Início de Vigência",
    id: "inicio_vigencia"
  },
  {
    nome: "Término de Vigência",
    id: "fim_vigencia"
  }
];

import { formatIsoDateToDDMMYYYY } from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";
import _ from "lodash";
export default {
  data() {
    return {
      quotationFilter: null,
      currentFilter: null,
      listTypesFilter: MOCK_TYPES_FILTER,
      header: tableHeaders,
      listColorByStatus: colorByStatus,
      options: defaultFilterOptions(),
      maskDate,
      timeout: null,
      dateTermValid,
      formatIsoDateToDDMMYYYY,
      initializeFilter: false,
      currentTab: 1,
      requiredInput
    };
  },
  watch: {
    options: {
      handler(value) {
        this.fetchPolicyAgro(this.getPayload(value));
      },
      deep: true
    },
    "quotationFilter.tipo"() {
      // Toda vez que trocar o filtro, tem que resertar o valor antigo
      if (this.initializeFilter) return;
      this.quotationFilter.valor = null;
      this.resetCurrentFilters();
    }
  },
  mixins: [LoadingRequest, CommonPayload],
  created() {
    this.initialize();
  },
  computed: {
    ...mapState("quotation", [
      "listApoliceAgro",
      "totalQuotation",
      "currentTakerQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"])
  },
  methods: {
    ...mapActions("quotation", ["requestListApoliceAgro", "resetCurrentFilters"]),
    initialize() {
      this.updateOptionsAccordingTabView(this.currentTab);
      this.initializeFilter = true;
      this.quotationFilter =
        this.nameOptionsDataTable == this.$route.name &&
        _.isObject(this.filterDataTable)
          ? this.filterDataTable
          : _.cloneDeep(MOCK_FILTER);
      this.searchByFilter();
      this.initializeFilter = false;
    },
    validateFilterTaker() {
      return (
        !this.quotationFilter.filter || Boolean(this.quotationFilter.filter?.id)
      );
    },
    validate() {
      const validateForm = this.quotationFilter.tipo.id
        ? this.$refs.form.validate()
        : true;
      return validateForm && this.validateFilterTaker();
    },
    searchByFilter() {
      if (!this.validate()) return;
      this.currentFilter = _.cloneDeep(this.quotationFilter);
      this.fetchPolicyAgro(this.getPayload(this.options));
    },
    resetFilter() {
      this.options = _.cloneDeep(defaultFilterOptions());
      this.quotationFilter = _.cloneDeep(MOCK_FILTER);
      this.currentFilter = _.cloneDeep(MOCK_FILTER);
      this.fetchPolicyAgro(this.getPayload(this.options));
    },
    fetchPolicyAgro(payload) {
      this.withLoading(this.requestListApoliceAgro(payload));
    },
    formatDates(startDate, endDate) {
      if (startDate && endDate) {
        return `${this.formatIsoDateToDDMMYYYY(
          startDate
        )} à ${this.formatIsoDateToDDMMYYYY(endDate)}`;
      } else {
        return "";
      }
    },
    borderColor(item) {
      const status =
        this.listColorByStatus.find(x => x.status == item.id) || DEFAULT_STATUS;
      return `policyTable__background-${status.color}`;
    },
    getFilterPayload() {
      const filterChosen =
        this.currentFilter.tipo.id == null
          ? ""
          : `&${this.currentFilter.tipo.id}=${this.currentFilter.valor}`;
      return `${filterChosen}`;
    },
    getPayload(options) {
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const directSort =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      // Pegar do headers o elemento que será ordenado
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      return `?page=${page}&page_size=${itemsPerPage}&sort=${sort}&direction=${directSort}${this.getFilterPayload()}`;
    },
    redirectToQuotation(item) {
      this.saveOptionsDataTable(this.payloadOptions(this.currentTab));
      this.$router.push({ name: "quotation element", params: { id: item.id } });
    }
  }
};
</script>
<style lang="sass">
.policyTable__
  &label
    color: #676778 !important
  &background-light-blue
    background-color: #d5ffff
    border-radius: 4px
    padding-top: 10px
    padding-bottom: 10px
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.policyTable
  thead th
    font-family: 'Poppins' !important
    font-size: 14px !important
  tbody tr
    cursor: pointer
.policyTable.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
</style>
